import { render, staticRenderFns } from "./bonus_return_balance.vue?vue&type=template&id=99618924&"
import script from "./bonus_return_balance.vue?vue&type=script&lang=js&"
export * from "./bonus_return_balance.vue?vue&type=script&lang=js&"
import style0 from "./bonus_return_balance.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports